import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthenticationService } from '../services/authentication/authentication.service';

export const superAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthenticationService);
  const router = inject(Router);

  if (auth.isSuperAdmin()) {
    return true;
  }

  return router.createUrlTree(['/analytics']);
};
